/* eslint-disable max-len */
import React from 'react'
import { ShimmerTitle } from 'react-shimmer-effects'

export default function c() {
    return (
        <div class="">
            {[...Array(4)].map((item,i)=>(
                <div class="flex justify-left items-center"item key={i}>
                    
                    <label htmlFor={`default-radio${i}`} class="text-f2 font-normal text-[#031624] cursor-pointer"><ShimmerTitle line={1} gap={6} variant="secondary" className="w-[300px]"/></label>
                </div>
            ))} 
        </div>
    )
}
